import { render, staticRenderFns } from "./Payment.vue?vue&type=template&id=3adf403a&scoped=true&"
var script = {}
import style0 from "./Payment.vue?vue&type=style&index=0&id=3adf403a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3adf403a",
  null
  
)

export default component.exports